import React from 'react';
import { usePermission } from '@backstage/plugin-permission-react';
import { BasicPermission } from '@backstage/plugin-permission-common';

type PermissionWrapperProps = {
  permission: BasicPermission;
  fallback?: React.ReactNode;
  children: React.ReactNode;
};

export const PermissionWrapper: React.FC<PermissionWrapperProps> = ({
  permission,
  fallback = null,
  children,
}) => {
  const { loading, allowed } = usePermission({
    permission,
    resourceRef: undefined,
  });

  if (loading) return fallback;
  if (!allowed) return null;

  return <>{children}</>;
};
